<span class="p-input-icon-left w-full">
  <i class="pi pi-search"></i>
  <input
    pInputText
    class="p-inputtext-sm w-full"
    (change)="change()"
    (search)="search()"
    [(ngModel)]="filterKeyword"
    [ngModelOptions]="{standalone: true}"
    placeholder="{{placeholder}}"
    type="search"
  />
</span>
